export enum WorkerAction {
  Create,
  Edit,
}
